export const COLLECTIONS_CHANGE_TRACKING = {
  exportCollections: {
    source: 'collections.export',
    id: 22004,
  },
  tierCreate: {
    source: 'collections.tier.create',
    id: 22005,
  },
  tierUpdate: {
    source: 'collections.tier.update',
    id: 22006,
  },
  tierDelete: {
    source: 'collections.tier.delete',
    id: 22007,
  },
  keyReasonCreate: {
    source: 'collections.key_reason.create',
    id: 22001,
  },
  keyReasonUpdate: {
    source: 'collections.key_reason.update',
    id: 22002,
  },
  keyReasonDelete: {
    source: 'collections.key_reason.delete',
    id: 22003,
  },
} as const;
